import React from "react";
import TopNav from "./header/TopNav";
import Footer from "./footer/Footer";
import MessengerCustomerChat from "react-messenger-customer-chat";
import CarComparison from "../../components/pages/comparador/CarComparison";
import useMediaQuery from "../../components/hooks/useMediaQuery ";
import Dot from "../../components/tools/dot/Dot";
import { Outlet } from "react-router-dom";

export default function Layout({
  infoJson,
  pontosVenda,
  allListaCarros,
  allListaComercias,
  allListaClassicos,
  allListaMotas,
  infoPrincipal,
  viatura,
  ficha,
  allinfoText,
  selectedCarsComparar,
  removeFromCompareAll,
  removeFromCompare,
  setTextoModal,
  textoModal,
  setShowModalComparison,
  showModalComparison,
}) {
  const isDesktop = useMediaQuery("(min-width: 992px)");
  return (
    <>
      <TopNav
        allinfo={pontosVenda}
        infoPrincipal={infoPrincipal}
        path={window.location.pathname}
        allListaCarros={allListaCarros}
        allListaComercias={allListaComercias}
        allListaClassicos={allListaClassicos}
        allListaMotas={allListaMotas}
        viatura={viatura}
        ficha={ficha}
        infoJson={infoJson}
        allinfoText={allinfoText}
      />
      <Outlet />
      <Footer
        allinfo={pontosVenda}
        infoPrincipal={infoPrincipal}
        infoJson={infoJson}
        allinfoText={allinfoText}
      />
      {infoJson.Stand.PluginFacebok.existe && (
        <MessengerCustomerChat
          pageId={infoJson.Stand.PluginFacebok.PageIdFacebook}
          appId={infoJson.Stand.PluginFacebok.AppIdFacebook}
          language="pt_PT"
        />
      )}
      {infoJson.Layout.Carros.Comparador && selectedCarsComparar.length > 0 && (
        <CarComparison
          infoJson={infoJson}
          selectedItems={selectedCarsComparar}
          removeFromCompare={removeFromCompare}
          show={showModalComparison}
          setShow={setShowModalComparison}
          textoModal={textoModal}
          setTextoModal={setTextoModal}
          ficha={ficha}
          removeFromCompareAll={removeFromCompareAll}
        />
      )}
      {isDesktop &&
        infoJson.Layout.ContactarDot &&
        infoPrincipal.length !== 0 && (
          <Dot
            allinfo={infoPrincipal[0]}
            selectedItems={selectedCarsComparar}
            infoJson={infoJson}
          />
        )}
    </>
  );
}
